import { LabelValueType } from "src/types/quasarType";

export function isString(arg: any): arg is string {
  return typeof arg === "string";
}

export function isLabelValue(arg: any): arg is LabelValueType {
  return arg.label !== undefined;
}
